import React, { useCallback, useEffect, useMemo } from 'react';
import './css/Anchor.css';
import classnames from 'classnames';
import PropTypes from 'prop-types';


import GalleriesAndVideosCountSection from './GalleriesAndVideosCountSection';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';


const SPECIAL_GUEST_ANCHOR_ID = 80;
const NAKED_NEWS_LIVE_ANCHOR_ID = 241;
const BASE_ROUTE = '/naked-news-anchor';

const Anchor = observer((props) => {
  const {
    anchor,
    isBroadcasting,
    isWhitelisted,
    fanZones,
    isGuestHomePage,
    isAnchorsPage,
    mediaTotals,
  } = props;

  const anchorHasFanzone = useCallback((anchorId) => {
    for (let i = 0; i < fanZones?.length; i++) {
      if (anchorId === fanZones[i]?.id) {
        return true;
      }
    }

    return false;
  }, [fanZones]);

  const buildAnchorLink = useCallback(() => {
    const nameArray = anchor.name.split(' ');
    let finalName = '';
    for (let i = 0; i < nameArray.length; i++) {
      finalName += `${nameArray[i]}-`;
    }

    return `${BASE_ROUTE}-${finalName.toLowerCase()}a${anchor.id}${anchorHasFanzone(anchor?.id) ? '?filter=fanzone' : ''}`;
  }, [anchor.id, anchor.name, anchorHasFanzone]);

  useEffect(() => {
    buildAnchorLink();
  }, [buildAnchorLink]);

  const anchorImage = useMemo(() => {
    if (isAnchorsPage && anchor?.anchorsPageImage) {
      return anchor?.anchorsPageImage;
    }

    return anchor?.biopic;
  }, [isAnchorsPage, anchor]);

  const anchorIsBroadcasting = useMemo(() => (
    isBroadcasting && isWhitelisted && !isGuestHomePage
  ), [isBroadcasting, isWhitelisted, isGuestHomePage]);

  if (anchor?.id === SPECIAL_GUEST_ANCHOR_ID || anchor?.id === NAKED_NEWS_LIVE_ANCHOR_ID) {
    return null;
  }

  return (
    <div
      className={classnames(
        'text-center',
        'ts',
        'col-xs-6',
        {
          'col-md-2': isGuestHomePage,
          'col-md-3 col-sm-4': !isGuestHomePage,
        })}
    >
      <div className="thumbnail">
        <Link to={buildAnchorLink()}>
          <img alt={anchor.name} className="img-responsive" src={anchorImage} />
        </Link>
        <div className="caption text-center">
          <p>{anchor.name}</p>
          {anchorIsBroadcasting && (
            <div className="flex items-center justify-center broadcast-indicator-wrapper">
              <div className="anchor-broadcast-indicator" />
              <h4 className="white">Online Now</h4>
            </div>
          )}
          <GalleriesAndVideosCountSection
            isGuestHomePage={isGuestHomePage}
            mediaCount={mediaTotals}
          />
        </div>
      </div>
    </div >
  );
});

export default React.memo(Anchor);


Anchor.propTypes = {
  anchor: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    anchorsPageImage: PropTypes.string,
    biopic: PropTypes.string,
  }).isRequired,
  fanZones: PropTypes.arrayOf(PropTypes.number).isRequired,
  isBroadcasting: PropTypes.bool.isRequired,
  isWhitelisted: PropTypes.bool.isRequired,
  isAnchorsPage: PropTypes.bool,
  isGuestHomePage: PropTypes.bool,
  mediaTotals: PropTypes.shape({
    totalPublicGalleries: PropTypes.number,
    totalPublicVideos: PropTypes.number,
  }),
};

Anchor.defaultProps = {
  isGuestHomePage: false,
  isAnchorsPage: false,
  mediaTotals: {
    totalPublicGalleries: 0,
    totalPublicVideos: 0,
  },
};
